<template>
  <public-transport-component />
</template>

<script>
import PublicTransportComponent from "@/components/public-transport/public-transport";

export default {
  components: {
    PublicTransportComponent
  }
};
</script>

<style></style>
